<ngx-spinner type="ball-atom"></ngx-spinner>
<div class="component-container">
  <div class="component-header">
    <h2>Large Shareholder Categories</h2>
    <div class="button-group">
      <!-- <button mat-raised-button color="primary" (click)="toggleSearch()">
        <mat-icon>search</mat-icon>
        @if (isSearchVisible) { Close search } @else { Search }
      </button> -->
      <button mat-raised-button color="primary" (click)="onCreateLargeShareholderCategory()">
        <mat-icon>add</mat-icon>
        Add Large Shareholder Category
      </button>
    </div>
  </div>
  <app-lookup-table-search-box
    [isSearchVisible]="isSearchVisible"
    (searchFilter)="onSearchFilterChange($event)">
  </app-lookup-table-search-box>
  <app-lookup-table
      [items]="largeShareholderCategories()"
      [columns]="largeShareholderCategoriesColumns()"
      (itemClick)="onItemSelected($event)"
      (editClick)="onEditLargeShareholderCategory($event)"
      (deleteClick)="onDeleteLargeShareholderCategory($event)"
      (itemSave)="onItemSave($event)"
      (itemAdd)="onItemAdd($event)">
    </app-lookup-table>
</div>
